import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { AssesmentUrl, BaseUrl, REACT_APP_ACESS_KEY_ID, REACT_APP_SECRET_ACESS_KEY } from '../../../Constants/Constants';
import { Button, Card, Input, message, Modal, Progress, Switch } from 'antd';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import './ManageCourse.css'
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import 'pdfjs-dist/webpack';
import {Skeleton} from 'antd';
import ReactPlayer from 'react-player';
import Dragger from 'antd/es/upload/Dragger';
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import AWS from 'aws-sdk'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AddParts from './AddParts/AddParts';
import { DeleteOutline } from '@mui/icons-material';
import AddTrainingModule from './AddTrainingModule/AddTrainingModule';
import Lottie from 'lottie-react';
import loadingJson from '../../../LottieAnimation/save-loading.json'

const ManageCourse = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const playerRef = useRef(null);
    const courseInputRef = useRef(null);
    const partInputRef = useRef(null);
    const topicInputRef = useRef(null);

    const profileData = JSON.parse(localStorage.getItem('Profile'));
    const userEmail = profileData.email;
    console.log(userEmail, 'profileData');




    const [courseData, setCourseData] = useState([]);
    // const [ partTitleInput, setPartTitleInput ] = useState(false);
    const [editingPartId, setEditingPartId] = useState(null);
    const [editingTrainingId, setEditingTrainingId] = useState(null);
    const [partTitles, setPartTitles] = useState({});
    const [partTitleVal, setPartTitleVal] = useState('');
    const [trainingTitles, setTrainingTitles] = useState({});
    const [trainingTitleVal, setTrainingTitleVal] = useState('');
    const [pdfModal, setPdfModal] = useState(false);
    const [videoModal, setVideoModal] = useState(false);
    const [draggerModal, setDraggerModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [videoUrl, setVideoUrl] = useState('');
    const [file, setfile] = useState([]);
    const [trainingId, setTrainingId] = useState('');
    const [uploadErr, setUploadErr] = useState('');
    const [errorFlag, setErrorFlag] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [courseName, setCourseName] = useState('');
    const [editCourse, setEditCourse] = useState(false);
    const [spinLoader, setSpinLoader] = useState(false);
    const [deleteDisable, setDeleteDisable] = useState(false);
    const [addTopicModal, setAddTopicModal] = useState(false);
    const [addTopicName, setAddTopicName] = useState('');
    const [addTopicFile, setAddTopicFile] = useState([]);
    const [addPartId, setAddPartId] = useState('');
    const [addTopicFileS3Url, setAddTopicFileS3Url] = useState('');
    const [addFileDuration, setAddFileDuration] = useState('');
    const [addFileType, setAddFileType] = useState('');
    const [Percent, setPercent] = useState('0');
    const [loading, setLoading] = useState(false);
    // const [ isPlaying, setIsPlaying ] = useState(false);
    const [renderPlayer, setRenderPlayer] = useState(true);
    const [saveAllow, setSaveAllow] = useState(false);
    const [s3Urls, setS3Urls] = useState([]);
    const [saveLoading, setSaveLoading] = useState(false);
    const [courseIgnoreBlur, setCourseIgnoreBlur] = useState(false);
    const [courseStatus, setCourseStatus] = useState(undefined);
    const [statusLoading, setStatusLoading] = useState(false);
    const [partIgnoreBlur, setPartIgnoreBlur] = useState(false);
    const [topicIgnoreBlur, setTopicIgnoreBlur] = useState(false);
    const [certificateEmail, setCertificateEmail] = useState(false);


    console.log(courseIgnoreBlur, 'courseIgnoreBlur')


    useEffect(() => {
        if (editCourse && courseInputRef.current) {
            courseInputRef.current.focus(); // Automatically focus the input when editCourse is true
        }
    }, [editCourse]); // Dependency on editCourse, runs when editCourse changes

    useEffect(() => {
        if (editingPartId !== null && partInputRef.current) {
            partInputRef.current.focus(); // Automatically focus the input when editCourse is true
        }
    }, [editingPartId]);

    useEffect(() => {
        if (editingTrainingId !== null && topicInputRef.current) {
            topicInputRef.current.focus(); // Automatically focus the input when editCourse is true
        }
    }, [editingTrainingId]);



    AWS.config.update({
        region: 'us-east-1',
        credentials: new AWS.Credentials({
            accessKeyId: REACT_APP_ACESS_KEY_ID,
            secretAccessKey: REACT_APP_SECRET_ACESS_KEY,
            s3ForcePathStyle: true,
        }),
    });

    const s3 = new AWS.S3();

    const findCourseName = () => {

        let body = {
            courseId: id
        }

        axios.post(`${BaseUrl}courses/findOne`, body, {withCredentials:true})
            .then((res) => {
                console.log(res.data, 'findOneResponse');
                if (res.data.data.length != 0) {
                    setCourseName(res.data.data[0].course_title);
                    setCourseStatus(res.data.data[0].is_active);
                    setCertificateEmail(res.data.data[0].certificate_email_required || false); // Add this line
                }
            })
            .catch((err) => {
                console.log(err.message, 'findOne API Error')
            })
    }
    console.log(saveAllow, 'addPartsValueFromProps')
    console.log(s3Urls, 'allS3Urls')

    const courseDetails = (value) => {
        setSaveAllow(value);


        let body = {
            courseId: id
        }

        axios.post(`${BaseUrl}course-parts/findOneByCourseId`, body, {withCredentials:true})
            .then((res) => {
                console.log(res.data.data, 'findOneByCourseId');
                if (res.data.data.length) {
                    const initialPartTitles = res.data.data.reduce((acc, item) => {
                        console.log(acc, 'accCourseData')
                        acc[item.partId] = item.partTitle;
                        return acc;
                    }, {});

                    setPartTitles(initialPartTitles);

                    const allS3Urls = res.data.data.map(item => (
                        item.training.map(trainings => (
                            trainings.module
                        )) 
                    ))

                    setS3Urls(allS3Urls.flat());


                    const initialTrainingTitles = res.data.data.reduce((acc, item) => {
                        item.training.forEach(training => {
                            acc[training.id] = training.name;
                        });
                        return acc;
                    }, {});
                    setTrainingTitles(initialTrainingTitles);
                    console.log(initialTrainingTitles, 'initialTrainingTitles')
                }
                setCourseData(res.data.data);
            })
    }

    useEffect(() => {
        courseDetails();
        findCourseName();
    }, [])

    const handleFileUpload = (files, trainingModuleDuration, trainingModuleType) => {
        if (files.length === 0) {
            message.error('Please Upload Document!');
            return;
        }
        console.log(files[0], "chan1")
        setLoading(true);
        setAddTopicFile(files); // Store the file for API request
        setAddFileDuration(`${Math.floor(trainingModuleDuration / 60)}:${Math.floor(trainingModuleDuration % 60).toString().padStart(2, '0')}`);
        setAddFileType(trainingModuleType);
        setLoading(false);
    };


    const handleCertificateToggle = async (checked, courseId) => {
    setCertificateEmail(checked);

    try {
        await axios.patch(
        `${BaseUrl}courses/${courseId}/certificate-email`,
        { enabled: checked },
        { withCredentials: true }
        );

        message.success(
        checked
            ? "Certification email enabled"
            : "Certification email disabled"
        );
    } catch (error) {
        message.error("Failed to update certification email setting");
    }
    };

    const addTopicUploadFileToS3 = (filess, trainingModuleDuration, trainingModuleType) => {
        if (filess.length === 0) {
            //   setVectorError('Please Upload Document!');
            message.error('Please Upload Document!');
            return;
        }
        setLoading(true);
        setPercent('0')

        const uploadPromises = filess.map((file) => {
            // const fileName = `https://trainingnexus.s3.amazonaws.com/DLP/${courseId}/${file.name}`
            const params = {
                Bucket: 'trainingnexus',
                Key: `DLP/${id}/${file.name}`,
                Body: file,
            };

            return new Promise((resolve, reject) => {
                s3.upload(params, { partSize: 5 * 1024 * 1024, queueSize: 1 })
                    .on('httpUploadProgress', (progress) => {
                        const uploadedPercentage = Math.round((progress.loaded / progress.total) * 100);
                        setPercent(uploadedPercentage);
                    })
                    .send((err, data) => {
                        if (err) {
                            reject(err);  
                        } else {
                            resolve(data); 
                            const moduleDuration = `${Math.floor(trainingModuleDuration / 60)}:${Math.floor(trainingModuleDuration % 60).toString().padStart(2, '0')}`
                            setAddFileDuration(moduleDuration);
                            setAddFileType(trainingModuleType);
                            setAddTopicFileS3Url(data.Location);
                        }
                    });
            });
        });

        Promise.all(uploadPromises)
            .then(() => {
                console.log("reached1")
                setLoading(false);
            })
            .catch((err) => {
                console.log(err, "upload err");
                setLoading(false);
            });
    };

    const uploadFileToS3 = (filess, trainingDuration, trainingType) => {
        setUploadLoading(true);
        const uploadPromises = filess.map((file) => {
            // const fileName = `https://trainingnexus.s3.amazonaws.com/DLP/${courseId}/${file.name}`
            const params = {
                Bucket: 'trainingnexus',
                Key: `DLP/${id}/${file.name}`,
                Body: file,
            }; 
            return new Promise((resolve, reject) => {   
                s3.upload(params,{partSize: 5 * 1024 * 1024, queueSize: 1})
                    .on('httpUploadProgress', (progress) => {
                        const uploadedPercentage = Math.round((progress.loaded / progress.total) * 100);
                        setPercent(uploadedPercentage);
                    })
                    .send((err, data) => {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(data);
                        }
                    });
            });
        });

        Promise.all(uploadPromises)
            .then((res) => {
                console.log(res[0].Location, "s3UploadData", trainingId);
                const moduleDuration = `${Math.floor(trainingDuration / 60)}:${Math.floor(trainingDuration % 60).toString().padStart(2, '0')}`
                if (res[0].Location) {
                    let body = {
                        trainingModuleId: trainingId,
                        trainingModule: res[0].Location,
                        trainingModuleType: trainingType, 
                        trainingDuration: moduleDuration
                    }

                    axios.post(`${BaseUrl}training-module/update`, body, {withCredentials:true})
                        .then((response) => {
                            console.log(response.data, 'updateResponse', trainingId, res[0].Location)
                            if (response.data.statuscode === 200) {
                                courseDetails();
                                setUploadLoading(false);
                                setDraggerModal(false);
                                setSaveAllow(true);
                                message.success("Module Changed Successfully!!");
                            }
                        })
                        .catch(err => {
                            console.log(err.message, 'Update Api Error');
                            setUploadLoading(false);
                            setDraggerModal(false);  
                            message.error(`Can't Update Module`);
                        })
                }
            })
            .catch((err) => {
                console.log(err, "upload err");
                setUploadLoading(false);
                setDraggerModal(false);
                message.error(`Can't change module`)
            });
    };

    const fileUpload = (filess, trainingDuration, trainingType) => {
        setUploadLoading(true);

        const moduleDuration = `${Math.floor(trainingDuration / 60)}:${Math.floor(trainingDuration % 60).toString().padStart(2, '0')}`
        const formData = new FormData();
        formData.append("trainingModuleId", trainingId);
        formData.append("trainingModuleDuration", moduleDuration);
        formData.append("trainingModuleType", trainingType);
        if (file) {
            formData.append("file", filess); // Attach file
        }

        axios.post(`${BaseUrl}training-module/update`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
            withCredentials:true
        })
            .then((response) => {
                if (response.data.statuscode === 200) {
                    courseDetails();
                    setUploadLoading(false);
                    setDraggerModal(false);
                    setSaveAllow(true);
                    message.success("Module Changed Successfully!!");
                }
            })
            .catch(err => {
                console.log(err.message, 'Update Api Error');
                setUploadLoading(false);
                setDraggerModal(false);
                message.error(`Can't Update Module`);
            })
    }
    const handleCourseInputChange = (e) => {
        setCourseName(e.target.value);
    };

    const handleCourseNameSave = (event) => {
        // setCourseIgnoreBlur(true);
        // event.preventDefault();
        // event.stopPropagation();
        setSpinLoader(true);
        let body = {
            "courseId": id,
            "courseTitle": courseName
        }

        axios.post(`${BaseUrl}courses/update`, body, {withCredentials:true})

            .then((res) => {
                console.log(res.data, 'updateResponse');

                if (res.data.statuscode === 200) { 
                    // setCourseName(courseName);
                    setEditCourse(false);
                    message.success('Course name changed successfully!');
                    setSpinLoader(false);
                } else {
                    setEditCourse(false);
                    setSpinLoader(false);
                    message.error(`Can't change the course name`)
                }
            }).catch((err) => {
                message.error(err.message);
                setEditCourse(false);
                setSpinLoader(false);
            })
    }

    const handleInputChange = (e, partId) => {
        setPartTitles({
            ...partTitles,
            [partId]: e.target.value,
        });

        setPartTitleVal(e.target.value);

    };

    const handlePartSave = (partId) => {
        setSpinLoader(true);

        if (partTitleVal !== '') {
            let body = {
                partId: partId,
                partTitle: partTitleVal
            }

            axios.post(`${BaseUrl}course-parts/update`, body, {withCredentials:true})
                .then((res) => {
                    if (res.data.statuscode === 200) {
                        setEditingPartId(null);
                        message.success('Part name changed successfully!');
                        setSpinLoader(false);
                    } else {
                        message.error('Error changing part name');
                        setSpinLoader(false);
                    }
                    console.log(res.data, 'responseData');
                })
                .catch((err) => {
                    message.error(err.message);
                    setSpinLoader(false);
                })

        } else {
            setEditingPartId(null);
            setSpinLoader(false);
        }

        console.log(partId, 'partId');
    };

    const handleTrainingInputChange = (e, trainingId) => {
        setTrainingTitles({
            ...trainingTitles,
            [trainingId]: e.target.value,
        });
        setTrainingTitleVal(e.target.value);
    };

    console.log(trainingTitleVal, 'trainingTitleVal')

    const handleSaveTrainingName = (trainingId) => {
        setSpinLoader(true);
        if (trainingTitleVal !== '') {
            let body = {
                trainingModuleId: trainingId,
                trainingModuleName: trainingTitleVal
            }
            axios.post(`${BaseUrl}training-module/update`, body, {withCredentials:true})
                .then((res) => {
                    console.log(res.data, 'trainingModuleAPI')
                    if (res.data.statuscode === 200) {
                        setEditingTrainingId(null);
                        setSpinLoader(false);
                        message.success('Training module name changed successfully!');
                    } else {
                        message.error('Error changing training module name');
                        setSpinLoader(false);
                    }
                }).catch((err) => {
                    message.error(err.message);
                    setSpinLoader(false);
                })
        } else {
            setEditingTrainingId(null);
            setSpinLoader(false);
        }

    };

    const handleShowModule = (module, type) => {
        console.log(module, 'trainingModule', type);
        if (type === 'pdf') {
            setPdfModal(true);
            setPdfUrl(module);
        } else if (type === 'mp4' || type === 'mov') {
            setVideoModal(true);
            setVideoUrl(module);
            // setIsPlaying(true);
        }
    }


    const handleShowDraggerModal = (trainingID) => {
        setTrainingId(trainingID);
        setDraggerModal(true);
    }
    // console.log(trainingId, 'trainingId')

    const handlePdfCancel = () => {
        setPdfModal(false);
        setPdfUrl('');
    }


    const handleVideoCancel = () => {
        setVideoModal(false);
        setVideoUrl('');
        if (playerRef.current) {
            playerRef.current.getInternalPlayer().pause(); // Pause the video
        }
        // setTimeout(() => setRenderPlayer(true), 0);
    };

    console.log(playerRef, 'isPlaying')

    const playerConfig = {
        file: {
            attributes: {
                controlsList: 'nodownload', // Disable the download button
            },
        },
    };

    console.log(courseData, 'courseDataManageCourse')
    const handleDeleteTrainingModule = (trainingId) => {


        for (const part of courseData) {
            const training = part.training.find(t => t.id === trainingId);
            if (training) {
                const trainingLength = part.training.length;
                console.log(`The length of the training array for trainingId ${trainingId} is ${trainingLength}`);
                // if (trainingLength > 1) {
                    setDeleteDisable(true);
                    let body = {
                        trainingModuleId: trainingId,
                        isActive: false
                    }

                    axios.post(`${BaseUrl}training-module/update`, body, {withCredentials:true})
                        .then((res) => {
                            console.log(res.data, 'updateResponse');

                            if (res.data.statuscode === 200) {
                                message.success('Module Deleted Successfully!');
                                courseDetails();
                                setDeleteDisable(false);
                            } else {
                                message.error('Error while deleting the module!')
                                setDeleteDisable(false);
                            }
                        })
                        .catch((err) => {
                            console.log(err.message, 'deleteTrainingModuleCatchErr');
                            message.error(err.message);
                        })
                } 
                // else {
                //     message.error('The part should have atleast one topic, Please update the topic!');
                //     setDeleteDisable(false);
                // }
            // }
        }


    }

    const addTrainingModule = (partId) => {
        setAddTopicModal(true);
        setAddPartId(partId);
    }

    const handleCancelTopicModal = () => {
        setAddPartId('');
        setAddTopicModal(false);
        setfile([]);
        setAddTopicName('');
        setAddTopicFile([]);
        setAddFileDuration('');
        setAddFileType('');
        setAddTopicFileS3Url('');
    }

    const handleCreateTopic = () => {
        // if (addTopicName === '' || !addTopicFile || !(addTopicFile instanceof File)) {
        //     message.error('Please fill all the fields with a valid file!');
        //     return;
        // }
        setLoading(true);

        const formData = new FormData();
        formData.append('partId', addPartId);
        formData.append('trainingModuleName', addTopicName);
        formData.append('trainingModuleType', addFileType);
        formData.append('trainingModuleDuration', addFileDuration);
        formData.append('file', addTopicFile); // Ensure it's a File object
        console.log(addTopicFile[0], "addTopicFile")
        console.log("FormData before sending:", [...formData.entries()]);

        axios.post(`${BaseUrl}training-module/addTrainingModule`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials:true
        })
            .then((res) => {
                setLoading(false);
                if (res.data.statuscode === 200) {
                    message.success('Topic added successfully!');
                    courseDetails(true);
                    handleCancelTopicModal();
                } else {
                    message.error('Error while adding topic');
                }
            })
            .catch((err) => {
                setLoading(false);
                message.error(err.message);
                console.log(err.message, 'add topic error');
            });
    };

    const handleBack = () => {
        if (saveAllow) {
            message.error('Please save the changes before exit!')
        } else {
            navigate(`/managecourses`);
        }
    }

    const handleSaveChanges = () => {
    setSaveLoading(true);
    
    if (saveAllow) {
        try {
            // Filter out invalid URLs and convert to standard format
            const standardS3Urls = s3Urls
                .filter(url => url && typeof url === 'string' && url.trim() !== '') // Remove null/undefined/empty
                .map(url => {
                    try {
                        // Remove query parameters (presigned URL params)
                        const baseUrl = url.split('?')[0];
                        
                        // Check if already in correct format
                        if (baseUrl.includes('trainingnexus.s3.us-east-1.amazonaws.com')) {
                            return baseUrl;
                        }
                        
                        // Convert from generic format to region-specific format
                        if (baseUrl.includes('trainingnexus.s3.amazonaws.com')) {
                            return baseUrl.replace(
                                'trainingnexus.s3.amazonaws.com',
                                'trainingnexus.s3.us-east-1.amazonaws.com'
                            );
                        }
                        
                        // Handle path-style URLs (s3.region.amazonaws.com/bucket/key)
                        if (baseUrl.includes('s3.us-east-1.amazonaws.com/trainingnexus')) {
                            const key = baseUrl.split('/trainingnexus/')[1];
                            return `https://trainingnexus.s3.us-east-1.amazonaws.com/${key}`;
                        }
                        
                        // If unknown format, log and return as-is
                        console.warn(' Unknown S3 URL format:', baseUrl);
                        return baseUrl;
                        
                    } catch (error) {
                        console.error('❌ Error processing URL:', url, error);
                        return null;
                    }
                })
                .filter(url => url !== null); // Remove any failed conversions

            // Validate that we have URLs to send
            if (standardS3Urls.length === 0) {
                message.error('No valid module URLs found. Please add at least one topic with a file.');
                setSaveLoading(false);
                return;
            }

            // Validate URL format before sending
            const invalidUrls = standardS3Urls.filter(url => {
                try {
                    new URL(url);
                    return false;
                } catch {
                    return true;
                }
            });

            if (invalidUrls.length > 0) {
                console.error('❌ Invalid URLs detected:', invalidUrls);
                message.error('Some module URLs are invalid. Please check and try again.');
                setSaveLoading(false);
                return;
            }

            let body = {
                course_id: id,
                url: standardS3Urls,
                mailid: userEmail
            }
            
            console.log("📤 Sending content_extraction with URLs:", standardS3Urls);
            console.log("📊 Total URLs:", standardS3Urls.length);
            
            axios.post(`${AssesmentUrl}content_extraction`, body, {withCredentials:true})
                .then((res) => {
                    if (res.data.status === 200) {
                        message.success('Changes Saved Successfully!');
                        setTimeout(() => {
                            navigate('/managecourses');
                        }, 1000);
                        setSaveLoading(false);
                        setSaveAllow(false);
                    } else {
                        message.error('Error while extracting files. Please try again later!');
                        setSaveLoading(false);
                    }
                })
                .catch(err => {
                    console.error('❌ Content extraction error:', err);
                    message.error(err.response?.data?.message || err.message || 'Failed to save changes');
                    setSaveLoading(false);
                });
                
        } catch (error) {
            console.error('❌ Error in handleSaveChanges:', error);
            message.error('An unexpected error occurred. Please try again.');
            setSaveLoading(false);
        }
        
    } else {
        navigate('/managecourses');
        setSaveLoading(false);
    }
}


    console.log(courseStatus, 'courseStatus')
    const handleStatusChange = (e) => {
        console.log(e, 'statusCheckedValue')
        setCourseStatus(e)
        setStatusLoading(true);
        let body = {
            courseId: id,
            isActive: e
        }

        axios.post(`${BaseUrl}courses/update`, body, {withCredentials:true})
            .then((res) => {
                console.log(res.data, 'courseStatusupdate');
                if (res.data.statuscode === 200) {
                    setStatusLoading(false);
                    message.success(`course status changed to ${e ? 'active' : 'inactive'} `)
                } else {
                    message.error('Error updating the course status!')
                    setStatusLoading(false);
                }

            }).catch((errr) => {
                message.error(errr.message);
                setStatusLoading(false);
            })

    } 


    return (
        <div className='Courses-main'>
            <Modal className='videoModalClass' title='Preview PDF' open={pdfModal} onOk={() => setPdfModal(false)} onCancel={handlePdfCancel} footer={false} >
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                    <Viewer fileUrl={pdfUrl} />
                </Worker>
            </Modal>
            <Modal className='videoModalClass' title='Preview Video' open={videoModal} onOk={() => setVideoModal(false)} onCancel={handleVideoCancel} footer={false} >
                {
                    // renderPlayer &&(
                    <ReactPlayer
                        ref={playerRef}
                        controls
                        config={playerConfig}
                        url={videoUrl}
                        width='100%'
                        playing={true}
                    />
                    // )
                }
            </Modal>
            <Modal title='Add Topic' onCancel={handleCancelTopicModal} open={addTopicModal} footer={false} >
                <div>
                    <h4>Topic</h4>
                    <Input className='courseTopicInput' placeholder='Enter topic name' value={addTopicName} onChange={(e) => setAddTopicName(e.target.value)} />
                    <Dragger className='moduleUploadDragger'

                        name='file'
                        action=''
                        // showUploadList={false}
                        maxCount={1}
                        beforeUpload={() => false}
                        // fileList={addTopicFile}
                        onRemove={() => setAddTopicFile([])}
                        onChange={(info) => {
                            console.log(info, 'addTopicInfo')
                            const fileObj = info.fileList.map((item) => item.originFileObj);
                            if (fileObj.length > 0) {
                                const file = fileObj[0];
                                const reader = new FileReader();
                                reader.onload = (e) => {
                                    console.log(file.type, 'fileTypeofCourseModule')
                                    if (addTopicModal) {
                                        if (file.type === 'application/pdf') {
                                            handleFileUpload(file, null, 'pdf');
                                            setAddTopicFile(file);
                                        } else if (file.type === 'video/mp4') {
                                            const video = document.createElement('video');
                                            video.src = e.target.result;
                                            console.log(file.type, 'fileObj')
                                            video.onloadedmetadata = () => {
                                                const duration = video.duration;
                                                handleFileUpload(file, duration, 'mp4');
                                                setAddTopicFile(file);
                                            };
                                        } else if (!errorFlag) {
                                            setErrorFlag(true);
                                            message.error('Please upload supported format files!');
                                            setTimeout(() => setErrorFlag(false), 2000);
                                        }
                                    } else if (!errorFlag) {
                                        setErrorFlag(true);
                                        message.error('Please upload a file to proceed!');
                                        setTimeout(() => setErrorFlag(false), 2000);
                                    }
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                        }
                        customRequest={({ onSuccess }) => onSuccess("ok")}
                    >
                        <p className='ant-upload-drag-icon'>
                            <InboxOutlined />
                        </p>
                        <p className='ant-upload-text'>
                            Click or drag file to this area to upload
                        </p>
                        <p className='ant-upload-hint'>
                            Note: Upload one file per topic.  Supports .pdf, .mp4 files
                        </p>
                    </Dragger>
                    <div className='addTopicBtnDiv'>
                        <Button onClick={handleCreateTopic} disabled={loading ? true : false}
                            className='SaveBtn'
                            block type='primary'>
                            {
                                loading == true ?
                                    <Progress strokeColor={'#fff'} className="progress" percent={Percent} type="circle" />
                                    :
                                    <>
                                        Add Topic
                                    </>
                            }
                        </Button>
                    </div>
                </div>
            </Modal>
            <Modal title='Change Module' open={draggerModal}
                onCancel={() => {
                    setTrainingId('');
                    setDraggerModal(false);
                    setUploadErr('');
                    setUploadLoading(false);
                }
                }
                footer={false} >
                {
                    uploadLoading ?
                        <div className='uploadLoaderImgDiv'>
                            <img src='/Loader/sandLoader.gif' alt='' className='uploadLoaderImgClass' />
                        </div>
                        :
                        <></>
                }
                <Dragger className='moduleUploadDragger'
                    name='file'
                    action=''
                    showUploadList={false}
                    maxCount={1}
                    beforeUpload={() => false}
                    onChange={(info) => {
                        const fileObj = info.fileList.map((item) => item.originFileObj);

                        if (fileObj.length > 0) {
                            const file = fileObj[0];
                            const maxPdfSize = 50 * 1024 * 1024; // 50MB for PDFs
                            const maxVideoSize = 500 * 1024 * 1024; // 500MB for Videos

                            // Read file
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                if (!draggerModal) {
                                    if (!errorFlag) {
                                        setErrorFlag(true);
                                        message.error("Please upload a file to proceed!");
                                        setTimeout(() => setErrorFlag(false), 2000);
                                    }
                                    return;
                                }

                                // **PDF Upload Validation**
                                if (file.type === "application/pdf") {
                                    if (file.size > maxPdfSize) {
                                        message.error("PDF file size must be less than 5MB.");
                                        return;
                                    }
                                    fileUpload(file, null, "pdf"); // No duration needed
                                }
                                // **MP4 Upload Validation**
                                else if (file.type === "video/mp4") {
                                    // if (file.size > maxVideoSize) {
                                    //     message.error("Video file size must be less than 50MB.");
                                    //     return;
                                    // }
                                    const video = document.createElement("video");
                                    video.src = e.target.result;
                                    video.onloadedmetadata = () => {
                                        const duration = video.duration;
                                        // if (duration > 300) { // Restrict to 5 mins (300 sec)
                                        //     message.error("Video duration must be less than 5 minutes.");
                                        //     return;
                                        // }
                                        fileUpload(file, duration, "mp4");
                                    };
                                }
                                // **Invalid File Format**
                                else {
                                    if (!errorFlag) {
                                        setErrorFlag(true);
                                        message.error("Please upload supported format files! (PDF/MP4)");
                                        setTimeout(() => setErrorFlag(false), 2000);
                                    }
                                }
                            };
                            reader.readAsDataURL(file);
                        }
                    }}
                    customRequest={({ onSuccess }) => onSuccess("ok")}
                >
                    <p className='ant-upload-drag-icon'>
                        <InboxOutlined />
                    </p>
                    <p className='ant-upload-text'>
                        Click or drag file to this area to upload
                    </p>
                    <p className='ant-upload-hint'>
                        Note: Upload one file per topic.  Supports .pdf, .mp4 files
                    </p>
                </Dragger>
                {/* <p style={{ color: 'red' }} >{uploadErr}</p> */}
            </Modal>
            <p className='back'>
                <span onClick={handleBack} style={{ color: '#4096FF', textDecoration: "underline" }}>
                    Courses
                </span>
                <span>
                    <ArrowForwardIosIcon className='arrow' />
                </span>
                <span style={{ color: '#454545', textDecoration: "" }}>
                    {courseName}
                </span>
            </p>

            <div className='manageCourseClass'>

                <h2 className='partNumber'>Manage Course - </h2>
                {
                    editCourse ?
                        <div className='partTitleInputDiv' >
                            <Input value={courseName}
                                onChange={(e) => handleCourseInputChange(e)}
                                ref={courseInputRef}
                                // onBlur={() => {
                                //     console.log('entering into blur function')
                                //     if( courseIgnoreBlur ){
                                //         setCourseIgnoreBlur(false);
                                //         return;
                                //     } else{
                                //         setSpinLoader(false);
                                //         setEditCourse(false);
                                //         findCourseName();
                                //     }
                                // }}
                                className='partTitleInput' placeholder='Change Part Title' />
                            <div className='partTitleInputActions'>
                                {
                                    spinLoader ?
                                        <img className='checkIconLoader' src='/Loader/spin.gif' alt='' />
                                        :

                                        <CheckIcon className='partTitleInputSubmit' onClick={() => handleCourseNameSave()} />
                                }
                                <ClearIcon className='partTitleInputCancel' onClick={() => {
                                    setSpinLoader(false);
                                    setEditCourse(false);
                                    findCourseName();
                                }} />
                            </div>
                        </div>
                        :
                        <h2 className='changePartTitle' onClick={() => setEditCourse(true)}>{courseName}</h2>
                }
            </div>
                <div className='togglesContainer'>
                <div className='statusInactiveDiv'>
                    {/* <h3 className='statusheadingClass'>Certificate Email</h3>
                    <Switch
                        checked={certificateEmail}
                        onChange={(checked) => handleCertificateToggle(checked, id)}
                        checkedChildren="Enabled"
                        unCheckedChildren="Disabled"
                        className='certificateSwitchClass'
                    /> */}
                </div>

                <div className='statusInactiveDiv'>
                    <h3 className='statusheadingClass'>Status</h3>
                    {courseStatus === undefined ? (
                        <Skeleton.Button active size="small" />
                    ) : (
                        <Switch 
                            checked={courseStatus}
                            onChange={handleStatusChange}
                            loading={statusLoading}
                            checkedChildren="Active"
                            unCheckedChildren="Inactive"
                            className='statusSwitchClass'
                        />
                    )} 
                </div>
            </div>

            <p className='managecourseNoteParagraph'><b style={{ color: 'red' }} >Note</b> : Please save the changes before exit</p>
            <div className='addPartsInManageCourse'>
                <AddParts props={courseData} addPartSuccess={(e) => courseDetails(e)} />
            </div>
            <div className='coursePartsWholeDiv'>
                {
                    courseData.map(item => (
                        <Card className='courseOverallCard' key={item.partId}>
                            <div className='partTitleDiv'>
                                <h3 className='partNumber'>{item.partNumber} - </h3>
                                {
                                    editingPartId === item.partId ?
                                        <div className='partTitleInputDiv' >
                                            <Input value={partTitles[item.partId]}
                                                ref={partInputRef}
                                                // onBlur={() => {
                                                //     setSpinLoader(false);
                                                //     setEditingPartId(null);
                                                //     courseDetails();
                                                // }}
                                                onChange={(e) => handleInputChange(e, item.partId)}
                                                className='partTitleInput' placeholder='Change Part Title' />
                                            <div className='partTitleInputActions'>
                                                {
                                                    spinLoader ?
                                                        <img className='checkIconLoader' src='/Loader/spin.gif' alt='' />
                                                        :
                                                        <CheckIcon className='partTitleInputSubmit' onClick={() => handlePartSave(item.partId)} />
                                                }
                                                <ClearIcon className='partTitleInputCancel' onClick={() => {
                                                    setSpinLoader(false);
                                                    setEditingPartId(null);
                                                    courseDetails();
                                                }} />
                                            </div>
                                        </div>
                                        :
                                        <h3 className='changePartTitle' onClick={() => setEditingPartId(item.partId)} >{partTitles[item.partId] || item.partTitle} </h3>
                                }
                            </div>
                            <div className='trainingModuleChangeDiv'>
                                <div className='addTrainingModuleDiv'>
                                    <h3>Topic</h3>
                                    <Button icon={<PlusOutlined />} type='primary'
                                        onClick={() => addTrainingModule(item.partId)}
                                    >Add Topic</Button>
                                </div>
                                {
                                    item.training.map(training => (
                                        <Card className='courseTrainingCard' key={training.id}>
                                            <div key={training.id} >
                                                <Button className='deleteTrainingModuleBtn' disabled={deleteDisable} icon={<DeleteOutline />}
                                                    onClick={() => handleDeleteTrainingModule(training.id)}
                                                />
                                            </div>
                                            <div className='partTitleDiv'>
                                                <h3 className='partNumber'>Topic Name - </h3>
                                                {
                                                    editingTrainingId === training.id ?
                                                        <div className='partTitleInputDiv' >
                                                            <Input value={trainingTitles[training.id]}
                                                                ref={topicInputRef}
                                                                // onBlur={() => {
                                                                //     setSpinLoader(false);
                                                                //         setEditingTrainingId(null);
                                                                //         courseDetails();
                                                                // }}
                                                                onChange={(e) => handleTrainingInputChange(e, training.id)}
                                                                className='partTitleInput' placeholder='Change Training Title' />
                                                            <div className='partTitleInputActions'>
                                                                {
                                                                    spinLoader ?
                                                                        <img className='checkIconLoader' src='/Loader/spin.gif' alt='' />
                                                                        :
                                                                        <CheckIcon className='partTitleInputSubmit' onClick={() => handleSaveTrainingName(training.id)} />
                                                                }
                                                                {/* <CheckIcon className='partTitleInputSubmit' onClick={() => handleSaveTrainingName(training.id)} /> */}
                                                                <ClearIcon className='partTitleInputCancel' onClick={() => {
                                                                    setSpinLoader(false);
                                                                    setEditingTrainingId(null);
                                                                    courseDetails();
                                                                }} />
                                                            </div>
                                                        </div>
                                                        :
                                                        <h3 className='changePartTitle' onClick={() => setEditingTrainingId(training.id)} >{trainingTitles[training.id] || training.name} </h3>
                                                }
                                            </div>
                                            <div className='moduleButtonDiv'>
                                                <Button type='primary' onClick={() => handleShowModule(training.module, training.type)} >Preview</Button>
                                                <Button className='changeModuleBtn' onClick={() => handleShowDraggerModal(training.id)}>Change Topic</Button>
                                            </div>
                                        </Card>

                                    ))
                                }
                            </div>
                        </Card>
                    ))
                }
            </div>
            {
                saveLoading ?
                    <div className='lottieDivClass'>
                        <Lottie
                            animationData={loadingJson}
                            autoplay={true}
                            style={{ width: 60 }}
                            className='lottieJsonClass'
                        />
                    </div>
                    :
                    <Button type='primary' block onClick={handleSaveChanges} >Save Changes</Button>

            }
        </div>
    )
}

export default ManageCourse